<template >
    <div class="full-page black">
        <div class="pa-5">
            <v-card max-width="600" class="mx-auto" primary>
                <v-img
                    cover
                    position="center"
                    :src="$store.state.base_url + '/uploads/subscriptions/' + details.id + '/' + details.banner">
                </v-img>
                <v-divider></v-divider>
                <v-list dense>
                    <v-list-item>
                        <v-list-item-content>
                            <v-text-field label="Name" 
                                dense 
                                outlined 
                                hide-details
                                prepend-icon="mdi-card-account-details"
                                v-model="user.name">
                            </v-text-field>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content>
                            <v-text-field label="Email" 
                                placeholder="Cannot be seen in public"
                                dense 
                                outlined 
                                hide-details
                                prepend-icon="mdi-email"
                                v-model="user.email">
                            </v-text-field>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content>
                            <v-text-field label="Mobile Number" 
                                placeholder="Cannot be seen in public"
                                dense 
                                outlined 
                                hide-details
                                prepend-icon="mdi-account-tie"
                                v-model="user.mobile_no">
                            </v-text-field>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content>
                            <v-text-field label="Affiliate/Company/Relationship (optional)"
                                placeholder="Cannot be seen in public" 
                                dense 
                                outlined 
                                hide-details
                                prepend-icon="mdi-domain"
                                v-model="user.company">
                            </v-text-field>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content>
                            <v-textarea 
                                prepend-icon="mdi-message-text"
                                label="Message"
                                placeholder="Share your message, dedication and picture with us. By clicking 'submit,' you voluntarily agree to share your message, image, and video. You understand that the Event admin (the requester or client of LiveSocialFeed) bears sole responsibility for approving or denying its publication on the designated event page. LiveSocialFeed and its agents have no liability in this regard." 
                                dense 
                                outlined 
                                hide-details
                                v-model="user.message">
                            </v-textarea>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content>
                            <v-file-input
                                show-size
                                outlined
                                accept="image/png, image/jpeg, image/bmp"
                                placeholder="Pick an avatar"
                                prepend-icon="mdi-camera"
                                label="Image (optional)"
                                dense
                                hide-details
                                @change="handleFile"
                                v-model="user.image"
                            ></v-file-input>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-card-text>
                    <v-btn block color="primary" @click="submit()" :disabled="$store.state.loading">
                        <v-icon>mdi-check</v-icon>
                        {{ $store.state.loading ? 'Processing' : 'Submit' }}
                    </v-btn>
                </v-card-text>
            </v-card>
        </div>
        <v-dialog v-model="error_dialog" width="400">
            <v-card dark color="red" class="darken-2">
                <v-list color="red" class="darken-2" dense>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-subtitle>ERRORS</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-for="er in errors" :key="er">
                        <v-list-item-content>{{ er }}</v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text small @click="error_dialog = false;">close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="success_dialog" max-width="400">
            <v-card color="success" dark>
                <v-card-title class="text-caption">SUCCESS!</v-card-title>
                <v-card-text>
                    <h3>Your message has been posted.</h3>
                </v-card-text>
                <v-card-actions>
                    <v-btn text small @click="success_dialog = false">close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    name : 'TestimonialView',
    data() {
        return {
            user : {},
            error_dialog : false,
            success_dialog : false,
            errors : [],
            details : {}
        }
    },
    mounted() {
        axios({
            url : this.$store.state.api_url + '/event-details/' + this.$route.params.code,
            method : 'GET',
        }).then(res => {
            this.details = res.data;
        });

    },
    methods : {
        submit() {
            let errors = [];
            if(this.details.require_email == 1) {
                if(!this.user.email) {
                    errors.push('Email is required');
                }
            }
            if(this.details.require_mobile == 1) {
                if(!this.user.mobile_no) {
                    errors.push('Mobile is required');
                }
            }

            if(errors.length > 0) {
                alert(errors.join('\n'));
                return;
            }

            if(!this.user.name) {
                alert('Please include your name/nickname');
                return;
            }
            if(!this.user.message && !this.user.image) {
                alert('Please enter a message OR attach a picture.');
                return;
            }

            this.$store.commit('setLoading', true);
            let formData = new FormData();
            formData.append('name', this.user.name ? this.user.name : '');
            formData.append('email', this.user.email ? this.user.email : '');
            formData.append('company', this.user.company ? this.user.company : '');
            formData.append('mobile_no', this.user.mobile_no ? this.user.mobile_no : '');
            formData.append('message', this.user.message ? this.user.message : '');
            formData.append('image', this.user.image);
            formData.append('subscription_id', this.details.id);
            formData.append('event_code', this.details.event_code);
            axios({
                url : this.$store.state.api_url + '/posts',
                method : 'POST',
                data : formData,
                headers : {
                    'Content-Type' : undefined
                }
            }).then(res => {
                this.$store.commit('setLoading', false);
                // this.$router.push({
                //     name : 'Details',
                //     params : {
                //         id : res.data.id,
                //         uid : res.data.uid
                //     }
                // });
                this.user = {};
                this.success_dialog = true;
            }).catch(err => {
                this.errors = err.response.data.errors;
                this.error_dialog = true;
                this.$store.commit('setLoading', false);
            });
        },
        async handleFile(file) {
            if (!file) return;

            const resizedFile = await this.resizeImage(file, 1000, 0.8); 
            const maxSize = 500 * 1024; // 500 KB

            // If file is small enough → don't resize
            if (file.size <= maxSize) {
                console.log("File is small, no resize needed.");
                return;
            }
            this.user.image = resizedFile;

            console.log("Original:", file.size / 1024, "KB");
            console.log("Resized:", resizedFile.size / 1024, "KB");

            // Upload this resizedFile instead of the original
        },
        resizeImage(file, maxWidth, quality = 0.8) {
            return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (e) => {
                const img = new Image();
                img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");

                let width = img.width;
                let height = img.height;

                // Resize proportionally
                if (width > maxWidth) {
                    height = (maxWidth / width) * height;
                    width = maxWidth;
                }

                canvas.width = width;
                canvas.height = height;

                ctx.drawImage(img, 0, 0, width, height);

                canvas.toBlob(
                    (blob) => {
                    blob.name = file.name; // keep same name
                    resolve(blob);
                    },
                    "image/jpeg",
                    quality
                );
                };
                img.src = e.target.result;
            };
            reader.readAsDataURL(file);
            });
        }
    }
}
</script>
<style scoped>
.full-page {
    width: 100%;
    height : 100%;
}
.bg {
    background-image: url('@/assets/background-1.png');
    background-size:cover;
    background-color: black;
    background-attachment: fixed;
}
</style>